import { makeRequest } from 'utils/requestLogger';

export default (id) =>
  makeRequest('get', `/api/roundtables/${id}/chord-diagram-public`);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/dataVisualization/createChordDiagramPublic.js